import { FieldLabel } from "@/components/FieldLabel";
import { MultiSelectDropdown, Option } from "@/components/MultipleSelectDropdown";

interface MultiSelectFormFieldProps {
  id?: string;
  label: string;
  description?: string;
  required?: boolean;
  options: Option[];
  selected: string[];
  onChange: (selected: string[]) => void;
  placeholder?: string;
  itemLabel?: string;
  error?: string;
}

/** Label + muted description + MultiSelectDropdown + error, for "select all that apply" master-data-backed questions. */
export const MultiSelectFormField = ({
  id,
  label,
  description,
  required,
  options,
  selected,
  onChange,
  placeholder = "Select all that apply...",
  itemLabel = "item",
  error,
}: MultiSelectFormFieldProps) => (
  <div data-field className="flex flex-col gap-2">
    <FieldLabel required={required} htmlFor={id}>
      {label}
    </FieldLabel>
    {description && (
      <p className="text-12 text-theme-text-muted leading-4 -mt-1">{description}</p>
    )}
    <MultiSelectDropdown
      options={options}
      value={options.filter((opt) => selected.includes(opt.value))}
      onChange={(next) => onChange(next.map((opt) => opt.value))}
      placeholder={placeholder}
      itemLabel={itemLabel}
      showPills
    />
    {error && (
      <p data-field-error className="error-message">
        {error}
      </p>
    )}
  </div>
);
